export const Selections = {
    selectionCount: ["SINGLE", "DOUBLE", "TREBLE", "ACCUMULATOR"],
    foldOptions: ["ACCUMULATOR"],
    allWinnersBonus: ["ALPHABET", "LUCKY15", "LUCKY31", "LUCKY63"],
    oneLoserBonus: ["LUCKY31", "LUCKY63"],
    oneWinnerConsolation: ["LUCKY15","LUCKY31", "LUCKY63"],
  };
  
  export const EachWayOptions = {
    multiple: [
      "DOUBLE",
      "TREBLE",
      "ACCUMULATOR",
      "TRIXIE",
      "PATENT",
      "YANKEE",
      "CANADIAN",
      "SUPERYANKEE",
      "HEINZ",
      "SUPERHEINZ",
      "GOLIATH",
      "LUCKY15",
      "LUCKY31",
      "LUCKY63",
      "ALPHABET",
      "ROUNDROBIN",
      "FLAG",
      "SUPERFLAG",
      "HEINZFLAG",
      "SUPERHEINZFLAG",
      "GOLIATHFLAG",
      "UNIONJACKTREBLES",
      "UNIONJACKTRIXIE",
      "UNIONJACKPATENT",
      "UNIONJACKROUNDROBIN",
    ],
    anyToCome: [
      "SINGLE_STAKES_ABOUT",
      "DOUBLE_STAKES_ABOUT",
      "ROUNDROBIN",
      "FLAG",
      "SUPERFLAG",
      "HEINZFLAG",
      "SUPERHEINZFLAG",
      "GOLIATHFLAG",
      "UNIONJACKROUNDROBIN",
    ],
  };
  
  export const BetTypes = {
    SINGLE: { numberOfRows: -1, types: [1] },
    DOUBLE: { numberOfRows: -1, types: [2] },
    TREBLE: { numberOfRows: -1, types: [3] },
    ACCUMULATOR: { numberOfRows: -1, types: [0] },
    TRIXIE: { numberOfRows: 3, types: [2, 3] },
    PATENT: { numberOfRows: 3, types: [1, 2, 3] },
    YANKEE: { numberOfRows: 4, types: [2, 3, 4] },
    CANADIAN: { numberOfRows: 5, types: [2, 3, 4, 5] },
    SUPERYANKEE: { numberOfRows: 5, types: [2, 3, 4, 5] },
    HEINZ: { numberOfRows: 6, types: [2, 3, 4, 5, 6] },
    SUPERHEINZ: { numberOfRows: 7, types: [2, 3, 4, 5, 6, 7] },
    GOLIATH: { numberOfRows: 8, types: [2, 3, 4, 5, 6, 7, 8] },
    LUCKY15: { numberOfRows: 4, types: [1, 2, 3, 4] },
    LUCKY31: { numberOfRows: 5, types: [1, 2, 3, 4, 5] },
    LUCKY63: { numberOfRows: 6, types: [1, 2, 3, 4, 5, 6] },
    ALPHABET: { numberOfRows: 6, types: [] },
    SINGLE_STAKES_ABOUT: { numberOfRows: 2, types: ["SSA"] },
    DOUBLE_STAKES_ABOUT: { numberOfRows: 2, types: ["DSA"] },
    ROUNDROBIN: { numberOfRows: 3, types: [2, 3, "SSA"] },
    FLAG: { numberOfRows: 4, types: [2, 3, 4, "SSA"] },
    SUPERFLAG: { numberOfRows: 5, types: [2, 3, 4, 5, "SSA"] },
    HEINZFLAG: { numberOfRows: 6, types: [2, 3, 4, 5, 6, "SSA"] },
    SUPERHEINZFLAG: { numberOfRows: 7, types: [2, 3, 4, 5, 6, 7, "SSA"] },
    GOLIATHFLAG: { numberOfRows: 8, types: [2, 3, 4, 5, 6, 7, 8, "SSA"] },
    UNIONJACKTREBLES: { numberOfRows: 9, types: [3] },
    UNIONJACKTRIXIE: { numberOfRows: 9, types: [2, 3] },
    UNIONJACKPATENT: { numberOfRows: 9, types: [1, 2, 3] },
    UNIONJACKROUNDROBIN: { numberOfRows: 9, types: [2, 3, "SSA"] },
  };
  